<template>
    <div class="color_select" :class="{'dark_selected': darkStyle, 'light_selected': lightStyle}" :style=style @click="action_Select">
        <v-icon class="check_icon">mdi-check-bold</v-icon>
    </div>
</template>


<script>
export default {
    props: {
        hex: String,
        index: Number,
        selectedHexString: String,
        usingCustomColor: Boolean
    },
    computed: {
        isSelected: function() { return this.usingCustomColor == false && this.hex == this.selectedHexString },
        style: function() { return 'background-color: ' + this.hex + ';' },
        brightness: function() {
            let color = this.hex.slice(1); // # 제거
            let rgb = parseInt(color, 16) // 16진수를 10진수로 변환
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff
            return 0.299 * r + 0.587 * g + 0.114 * b // 밝기 계산
        },
        selectedStyle: function() {
            if (this.isSelected == false) { return '' }
            return this.brightness < 111 ? 'dark_selected' : 'light_selected'
        },
        darkStyle: function() { return this.selectedStyle == 'dark_selected' },
        lightStyle: function() { return this.selectedStyle == 'light_selected' }
    },
    methods: {
        action_Select() {
            this.$emit('selectColor', this.hex, this.index)
        }
    }
}
</script>